import React from 'react';
import { isEmpty } from 'lodash';

interface IMoney {
  currency?: string;
  amount?: string;
}

interface ICSPInventory {
  usedTotal?: number;
  newTotal?: number;
  newLowPrice?: IMoney;
  usedLowPrice?: IMoney;
}

function findLowestPrice(inventory: ICSPInventory): IMoney {
  if (isEmpty(inventory.usedLowPrice)) {
    return inventory.newLowPrice;
  }

  if (isEmpty(inventory.newLowPrice)) {
    return inventory.usedLowPrice;
  }

  if (inventory.newLowPrice.amount < inventory.usedLowPrice.amount) {
    return inventory.newLowPrice;
  }

  return inventory.usedLowPrice;
}

function renderMeta(count: number, price: IMoney) {
  if (!price) {
    return null;
  }

  return (
    <span className="d-none">
      <meta itemProp="offerCount" content={String(count)} />
      <meta itemProp="priceCurrency" content={price.currency} />
      <meta itemProp="lowPrice" content={price.amount} />
    </span>
  );
}

interface IBrandMetaDataProps {
  brandName: string;
}

export function BrandMetaData(props: IBrandMetaDataProps) {
  if (!props.brandName) {
    return null;
  }

  return (
    <meta
      content={props.brandName}
      itemType="http://schema.org/Brand"
      itemProp="brand"
    />
  );
}

interface IPriceMetaProps {
  inventory: ICSPInventory;
  newOnly?: boolean;
  usedOnly?: boolean;
}

export function PriceMetaData(props: IPriceMetaProps) {
  const { inventory, newOnly, usedOnly } = props;

  if (!inventory) {
    return null;
  }

  if (newOnly) {
    return renderMeta(inventory.newTotal, inventory.newLowPrice);
  }

  if (usedOnly) {
    return renderMeta(inventory.usedTotal, inventory.usedLowPrice);
  }

  const total = inventory.usedTotal + inventory.newTotal;
  const lowestPrice = findLowestPrice(inventory);

  return renderMeta(total, lowestPrice);
}

interface INamedMetaDataProps {
  title: string;
}

export function NameMetaData(props: INamedMetaDataProps) {
  if (!props.title) {
    return null;
  }

  return <meta content={props.title} itemProp="name" />;
}
